import React from "react";

const StakingStats = () => {
  return (
    <section className="w-full px-4">
      <div className="mx-auto flex flex-col md:flex-row items-center justify-between gap-8 md:gap-0 p-6 md:p-[42px] bg-[#2a2540] rounded-2xl flex w-[1342px] items-center justify-between p-[42px] relative bg-[#2a2540] rounded-2xl">
        {/* Total Staked */}
        <div className="flex flex-col items-center gap-3">
          <h2 className="bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text text-transparent font-bold text-4xl md:text-[56px] leading-tight text-center">
            1.2M $BABYU
          </h2>
          <p className="text-neutral-100 text-lg md:text-xl text-center">
            Total Staked
          </p>
        </div>

        {/* Line Image */}
        <img
          className="hidden md:block w-px h-[127px] object-cover"
          alt="Line"
          src="https://c.animaapp.com/mckjlb7mz737rs/img/line-6.svg"
        />

        {/* Active Stakers */}
        <div className="flex flex-col items-center gap-3">
          <h2 className="bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text text-transparent font-bold text-4xl md:text-[56px] leading-tight text-center">
            3.5K
          </h2>
          <p className="text-neutral-100 text-lg md:text-xl text-center">
            Active Stakers
          </p>
        </div>

        {/* Line Image */}
        <img
          className="hidden md:block w-px h-[127px] object-cover"
          alt="Line"
          src="https://c.animaapp.com/mckjlb7mz737rs/img/line-6.svg"
        />

        {/* Rewards Distributed */}
        <div className="flex flex-col items-center gap-3">
          <h2 className="bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text text-transparent font-bold text-4xl md:text-[56px] leading-tight text-center">
            85K $BABYU
          </h2>
          <p className="text-neutral-100 text-lg md:text-xl text-center">
            Rewards Distributed
          </p>
        </div>
      </div>
    </section>
  );
};

export default StakingStats;
